import CGB from "assets/icons/icon-circle-gray-blk.png";
import CGR from "assets/icons/icon-circle-gray-red.png";
import CGY from "assets/icons/icon-circle-gray-yell.png";
import WGR from "assets/icons/icon-wifi-gray-red.png";
import WGB from "assets/icons/icon-wifi-gray-blk.png";
import WGY from "assets/icons/icon-wifi-gray-yell.png";
import CB from "assets/icons/circle-blue-32.png";
import CG from "assets/icons/circle-green-32.png";

export const showSpecifiCarTrackLocation = (
  track,
  carTrackPolyLineState,
  setCarTrackPolyLineState,
  carHistoryMarkers,
  setCarHistoryMarkers,
  mapData,
  mapsData,
  setHoverState,
  clickState,
  setClickState
) => {
  carTrackPolyLineState.forEach((polyLine) => {
    polyLine.setMap(null);
  });
  carHistoryMarkers.forEach((marker) => {
    marker.marker.setMap(null);
  });
  setCarTrackPolyLineState([]);
  setCarHistoryMarkers([]);
  var makersData = [];
  let specificCarTrackLatLong = [];
  for (var i = 0; i < track.length; i++) {
    let latLng = new mapsData.LatLng(track[i].Latitude, track[i].Longitude);
    specificCarTrackLatLong.push(latLng);
    addPositionMarker(
      track[i],
      makersData,
      i + 1,
      track.length,
      mapData,
      mapsData,
      setHoverState,
      clickState,
      setClickState
    );
  }

  setCarHistoryMarkers(makersData);
  let carflightPath =
    mapsData &&
    new mapsData.Polyline({
      path: specificCarTrackLatLong,
      strokeColor: "#FFFFFF",
      strokeOpacity: 1,
      strokeWeight: 2,
    });
  if (carflightPath) {
    carflightPath.setMap(mapData);
    setCarTrackPolyLineState([carflightPath]);
  }
};

function addPositionMarker(
  data,
  makersData,
  index,
  length,
  mapData,
  mapsData,
  setHoverState,
  clickState,
  setClickState
) {
  if (mapsData) {
    var wifiIcon = {
      url: WGB,
      anchor: new mapsData.Point(11, 11), // 24 x 24 marker so anchor point 11,11 is right in the middle of the png
      size: new mapsData.Size(22, 22),
    };

    var wifiPaceWarningIcon = {
      url: WGY,
      anchor: new mapsData.Point(11, 11), // 24 x 24 marker so anchor point 11,11 is right in the middle of the png
      size: new mapsData.Size(22, 22),
    };

    var wifiPaceCriticalIcon = {
      url: WGR,
      anchor: new mapsData.Point(11, 11), // 24 x 24 marker so anchor point 11,11 is right in the middle of the png
      size: new mapsData.Size(22, 22),
    };

    var gprsIcon = {
      url: CGB,
      anchor: new mapsData.Point(11, 11), // 24 x 24 marker so anchor point 11,11 is right in the middle of the png
      size: new mapsData.Size(22, 22),
    };

    var gprsIconPaceWarning = {
      url: CGY,
      anchor: new mapsData.Point(11, 11), // 24 x 24 marker so anchor point 11,11 is right in the middle of the png
      size: new mapsData.Size(22, 22),
    };

    var gprsIconPaceCritical = {
      url: CGR,
      anchor: new mapsData.Point(11, 11), // 24 x 24 marker so anchor point 11,11 is right in the middle of the png
      size: new mapsData.Size(22, 22),
    };

    var endIcon = {
      url: CG,
      anchor: new mapsData.Point(16, 16), // 32 x 32 marker so anchor point 16,16 is right in the middle of the png
      size: new mapsData.Size(32, 32),
    };

    var startIcon = {
      url: CB,
      anchor: new mapsData.Point(16, 16), // 32 x 32 marker so anchor point 16,16 is right in the middle of the png
      size: new mapsData.Size(32, 32),
    };
  }

  let positionMarker = {};
  let iconToUse = gprsIcon;
  if (data.PrimaryNetwork === 3) {
    if (data.PaceStatus !== 1)
      iconToUse =
        data.PaceStatus === 2 ? gprsIconPaceWarning : gprsIconPaceCritical;
  } else {
    iconToUse = wifiIcon;
    if (data.PaceStatus !== 1)
      iconToUse =
        data.PaceStatus === 2 ? wifiPaceWarningIcon : wifiPaceCriticalIcon;
  }

  const markerImg = document.createElement("img");
  const markerIcon = index === 1 ? startIcon : index === length ? endIcon : iconToUse;

  markerImg.src = markerIcon.url;
  markerImg.style.width = `${markerIcon.size.width}px`;
  markerImg.style.height = `${markerIcon.size.height}px`;
  markerImg.style.transform = `translate(-${markerIcon.anchor.x}px, -${markerIcon.anchor.y}px)`;
  markerImg.style.position = "absolute";
  markerImg.style.pointerEvents = "auto";

  positionMarker.marker = new mapsData.marker.AdvancedMarkerElement({
    position: new mapsData.LatLng(data.Latitude, data.Longitude),
    map: mapData,
    content: markerImg,
  });

  positionMarker.data = data;
  makersData.push(positionMarker);
  markerImg.addEventListener("mouseenter", (event) => {
      var offset = {
        x: 20,
        y: 20,
      };

      let obj = {
        state: true,
        position: "fixed",
        data: positionMarker.data,
        top: event.clientY + window.scrollY + offset.y + "px",
        left: event.clientX + window.scrollX + offset.x + "px",
      };
      setHoverState(obj);
    }
  );

  markerImg.addEventListener("mouseleave", () => {
    setHoverState({});
  });

  markerImg.addEventListener("click", (event) => {
    if (clickState?.data?.Latitude === positionMarker.data.Latitude &&
      clickState.data.Longitude === positionMarker.data.Longitude) {
      setClickState({});
    } else {
      setHoverState({});
      var offset = {
        x: 0,
        y: 0,
      };
      let obj = {
        state: true,
        position: "fixed",
        data: positionMarker.data,
        top: event.clientY + window.scrollY + (offset.y + 2) + "px",
        left: event.clientX + window.scrollX + (offset.x - 0.5) + "px",
      };
      setClickState(obj);
    }
  });
}
